// good_english_data_1a_l01.js
// Good English 1A L01 - Six in a bed
// 路由：/ge/1a/l01
//
// 音频规则：
// - 非最后一页: end = 下一个 start - 1
// - 最后一页: 无 end（播放到音频结尾）

const MEDIA_BASE = '/media/good-english/1a/l01';
const V = 'v1';

export const dataGoodEnglish1aL01 = {
  id: '1a-l01',
  title: 'L01 Six in a bed',
  mediaBase: MEDIA_BASE,
  audio: `${MEDIA_BASE}/story.mp3?${V}`,
  pages: [
    { image: `${MEDIA_BASE}/page1.png?${V}`, text: 'Mum and Dad.',                  start: 20, end: 26 },  // 27-1
    { image: `${MEDIA_BASE}/page2.png?${V}`, text: 'Mum, Kipper and Dad.',          start: 27, end: 33 },  // 34-1
    { image: `${MEDIA_BASE}/page3.png?${V}`, text: 'Mum, Kipper, Dad and Chip.',    start: 34, end: 41 },  // 42-1
    { image: `${MEDIA_BASE}/page4.png?${V}`, text: 'Biff, Mum, Kipper, Dad, Chip', start: 42, end: 51 },  // 52-1
    { image: `${MEDIA_BASE}/page5.png?${V}`, text: 'and Floppy!',                   start: 51 },  // 最后页，无 end
  ],
};
